import { FC } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import {
  AdvancedSearchPage,
  CallNumbersPage,
  ConditionalRoute,
  CourseReserveDetailsPage,
  CourseReservesPage,
  HoldsAndCheckoutsPage,
  InstanceDetailsPage,
  NavigationLayout,
  NotFoundPage,
  PreferencesPage,
  ProjectsDetailsPage,
  ProjectsPage,
  RecentActivityPage,
  SavedPage,
  SearchResultsPage,
} from '@app/components';
import { useHoldsAndCheckoutsPageConfig } from '@app/hooks';
import { FEATURE, ROUTE } from '@app/constants';

export const getPathWithDescendantRoutes = (route: ROUTE): string =>
  `${route}/*`;

export const MainPage: FC = () => {
  const { holdsAndCheckoutsRoute } = useHoldsAndCheckoutsPageConfig();

  return (
    <Routes>
      <Route element={<NavigationLayout />}>
        <Route
          path={getPathWithDescendantRoutes(holdsAndCheckoutsRoute)}
          element={
            <ConditionalRoute
              flagsToMatch={[
                { name: FEATURE.holdsAndCheckouts, isActiveIfNotFound: true },
              ]}
            >
              <HoldsAndCheckoutsPage />
            </ConditionalRoute>
          }
        />
        <Route path={ROUTE.instanceDetails} element={<InstanceDetailsPage />} />
        <Route path={ROUTE.search} element={<SearchResultsPage />} />
        <Route path={ROUTE.advancedSearch} element={<AdvancedSearchPage />} />
        <Route
          path={ROUTE.courseReserveDetails}
          element={
            <ConditionalRoute flagsToMatch={[{ name: FEATURE.courseReserves }]}>
              <CourseReserveDetailsPage />
            </ConditionalRoute>
          }
        />
        <Route
          path={ROUTE.courseReserves}
          element={
            <ConditionalRoute flagsToMatch={[{ name: FEATURE.courseReserves }]}>
              <CourseReservesPage />
            </ConditionalRoute>
          }
        />
        <Route
          path={ROUTE.callNumbers}
          element={
            <ConditionalRoute flagsToMatch={[{ name: FEATURE.callNumbers }]}>
              <CallNumbersPage />
            </ConditionalRoute>
          }
        />
        <Route
          path={ROUTE.preferences}
          element={
            <ConditionalRoute
              flagsToMatch={[{ name: FEATURE.consortiaLoginFlow }]}
              shouldRenderOnFalse
            >
              <PreferencesPage />
            </ConditionalRoute>
          }
        />
        <Route path={ROUTE.projects} element={<ProjectsPage />} />
        <Route
          path={getPathWithDescendantRoutes(ROUTE.projectsDetails)}
          element={<ProjectsDetailsPage />}
        />
        <Route
          path={getPathWithDescendantRoutes(ROUTE.recentActivity)}
          element={<RecentActivityPage />}
        />
        <Route
          path={getPathWithDescendantRoutes(ROUTE.saved)}
          element={<SavedPage />}
        />
        <Route path={ROUTE.notFound} element={<NotFoundPage />} />
        <Route
          path={ROUTE.root}
          element={<Navigate replace to={ROUTE.search} />}
        />
        <Route path="*" element={<Navigate replace to={ROUTE.notFound} />} />
      </Route>
    </Routes>
  );
};
